var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { bindable } from "aurelia-templating";
import { autoinject, transient } from "aurelia-dependency-injection";
import * as Enumerable from "linq";
import { Messages } from "../../../configuration/event-messages.constants";
import { EventAggregator } from "aurelia-event-aggregator";
import { BindingEngine } from "aurelia-binding";
import { MobileHelper } from "../../../helpers/mobile-helper";
var dropdown = require("./combo-box-dropdown.html");
var ComboBox = /** @class */ (function () {
    function ComboBox(element, eventAggrigator, bindingEngine) {
        var _this = this;
        this.element = element;
        this.eventAggrigator = eventAggrigator;
        this.bindingEngine = bindingEngine;
        this.isMobile = MobileHelper.isMobileDevice();
        // private Properties
        this.indexFocusedLi = 0;
        this.canEdit = !MobileHelper.isMobileDevice();
        this.placeholder = "";
        this.info = "";
        this.itemsToHide = [];
        this.isSearchable = true;
        this._focusCount = 0;
        this.select = function (item) {
            if (item != null && !_this.isGroupHeader(item) && !_this.isItemDisabled(item)) {
                _this.selectedItem = item;
                _this.selectedValue = _this.getValue(item);
                _this.isEditing = false;
                _this.isDropdownOpen = false;
                _this.onSelect();
            }
        };
        this.stopPropagation = function (e) {
            e.stopPropagation();
        };
        this.closePopup = function () {
            _this.isEditing = false;
            _this.isDropdownOpen = false;
        };
        this.onKeyDown = function (event) {
            if (!_this.disabled && !_this.readonly) {
                _this.isDropdownOpen = true;
                _this.onKeyDownNavigation(event);
            }
        };
        this.subscriptionToDocumentClickEvent = eventAggrigator.subscribe(Messages.documentClick, this.closePopup);
    }
    ComboBox.prototype.isGroupHeader = function (item) {
        return !!(this.groupHeaderPath && item && item[this.groupHeaderPath]);
    };
    ComboBox.prototype.isItemDisabled = function (item) {
        return !!(this.disabledItemPath && item && item[this.disabledItemPath]);
    };
    ComboBox.prototype.itemsToHideChanged = function (newValue, oldValue) {
        var _this = this;
        if (this.itemsToHideObserver) {
            this.itemsToHideObserver.dispose();
            this.itemsToHideObserver = null;
        }
        if (newValue) {
            this.bindingEngine.collectionObserver(newValue).subscribe(function () {
                _this.filteredItemSource = _this.internalItemSource.toArray();
            });
        }
        this.filteredItemSource = this.internalItemSource.toArray();
    };
    Object.defineProperty(ComboBox.prototype, "invertDropdown", {
        // Bound in the view (class interpolation), so it runs every dirty-check. Measure geometry only ONCE per
        // open (once the dropdown element exists) and freeze the result; otherwise the position flip-flops = flicker.
        get: function () {
            if (!this.isDropdownOpen) {
                this._invertComputed = false;
                return this._invertDropdown;
            }
            if (!this._invertComputed && this.dropdownElement) {
                this.updateInvertDropdown();
                this._invertComputed = true;
            }
            return this._invertDropdown;
        },
        enumerable: false,
        configurable: true
    });
    ComboBox.prototype.updateInvertDropdown = function () {
        var scrollViewer = this.getScrollParent(this.dropdownElement);
        if (scrollViewer) {
            if (!this.scrollViewerTop) {
                this.scrollViewerTop = this.getTop(scrollViewer);
            }
            var dropdownPosition = ((this.getTop($(this.dropdownElement).parent().get(0)) + $(this.dropdownElement).parent().get(0).clientHeight) - this.scrollViewerTop) + this.dropdownElement.clientHeight;
            if (scrollViewer.nodeType != document.DOCUMENT_FRAGMENT_NODE && scrollViewer.clientHeight) {
                this._invertDropdown = scrollViewer.clientHeight < dropdownPosition;
            }
            else if (scrollViewer.nodeType == document.DOCUMENT_NODE) {
                this._invertDropdown = false;
            }
        }
    };
    Object.defineProperty(ComboBox.prototype, "internalItemSource", {
        get: function () {
            var _this = this;
            if (this.itemsToHide && this.itemsToHide.length > 0 && this.itemSource) {
                var valuesToHide_1 = this.selectedValuePath ? this.itemsToHide.map(function (x) { return x[_this.selectedValuePath]; }) : this.itemsToHide;
                var selectedItemStringified_1 = JSON.stringify(this.selectedItem);
                var condition_1 = function (x) { return JSON.stringify(x) == selectedItemStringified_1 || x == _this.selectedItem; };
                return Enumerable.from(this.itemSource).where(function (x) { return valuesToHide_1.every(function (z) { return z != (_this.selectedValuePath ? x[_this.selectedValuePath] : x); }) || condition_1(x); });
            }
            return Enumerable.from(this.itemSource);
        },
        enumerable: false,
        configurable: true
    });
    ComboBox.prototype.attached = function () {
        if (this.isAttached) {
            return;
        }
        this.isAttached = true;
        this.dropDownContext = new DropDownContext(this);
        if (this.input) {
            this.input.addEventListener("keydown", this.onKeyDown, false);
        }
        this.selectedValueChanged(this.selectedValue, undefined);
        this.itemSourceChanged(this.itemSource, undefined);
        this.dropdown = dropdown;
    };
    ComboBox.prototype.detached = function () {
        this.isAttached = false;
        if (this.input) {
            this.input.removeEventListener("keydown", this.onKeyDown, false);
        }
        if (this.subscriptionToDocumentClickEvent) {
            this.subscriptionToDocumentClickEvent.dispose();
        }
        if (this.dropDownContext) {
            this.dropDownContext.comboBoxContext = null;
            this.dropDownContext = null;
        }
        if (this.itemsToHideObserver) {
            this.itemsToHideObserver.dispose();
        }
    };
    ComboBox.prototype.getScrollParent = function (node) {
        if (node === null) {
            return null;
        }
        if (this.hasScroll(node)) {
            return node;
        }
        else {
            return this.getScrollParent(node.parentNode);
        }
    };
    ComboBox.prototype.hasScroll = function (el) {
        if (el.nodeType != document.ELEMENT_NODE) {
            return true;
        }
        var $el = $(el), sY = $el.css("overflow-y"), hidden = "hidden", // minifiers would like this better
        visible = "visible", scroll = "scroll";
        if (sY === hidden || sY === visible) {
            return false;
        }
        if (sY === scroll) {
            return true;
        }
        // compare client and scroll dimensions to see if a scrollbar is needed
        return $el.innerHeight() < el.scrollHeight || // make use of potential short circuit
            $el.innerWidth() < el.scrollWidth;
    };
    ComboBox.prototype.selectItemByIndex = function (index) {
        this.select(this.filteredItemSource[index]);
    };
    ComboBox.prototype.onKeyDownNavigation = function ($event) {
        var code = $event.keyCode;
        if (code === 13) {
            this.selectItemByIndex(this.indexFocusedLi);
        }
        else if (code === 38) {
            this.indexFocusedLi = this.nextSelectableIndex(this.indexFocusedLi, -1);
        }
        else if (code === 40) {
            this.indexFocusedLi = this.nextSelectableIndex(this.indexFocusedLi, 1);
        }
    };
    // Step from `from` in `step` direction, skipping group headers; stays put if none selectable.
    ComboBox.prototype.nextSelectableIndex = function (from, step) {
        var items = this.filteredItemSource || [];
        var i = from + step;
        while (i >= 0 && i < items.length) {
            if (!this.isGroupHeader(items[i]) && !this.isItemDisabled(items[i]))
                return i;
            i += step;
        }
        return from;
    };
    ComboBox.prototype.getDisplayName = function (item) {
        if (this.displayMemberPath && item) {
            if (typeof this.displayMemberPath == "function") {
                return this.displayMemberPath(item);
            }
            else {
                return item[this.displayMemberPath];
            }
        }
        return item;
    };
    ComboBox.prototype.getValue = function (item) {
        return this.selectedValuePath && item != null ? item[this.selectedValuePath] : item;
    };
    ComboBox.prototype.selectedValueChanged = function (newValue, oldValue) {
        var _this = this;
        if (newValue == oldValue || !this.isAttached) {
            return;
        }
        if (!this.filteredItemSource) {
            this.filteredItemSource = this.itemSource ? this.itemSource.slice(0) : this.itemSource;
        }
        if (this.itemSource) {
            this.selectedItem = Enumerable.from(this.itemSource).firstOrDefault(function (x) { return _this.getValue(x) == newValue; });
            this.indexFocusedLi = this.filteredItemSource.indexOf(this.selectedItem) % this.filteredItemSource.length;
            setTimeout(function () {
                var itemChangedEvent = new CustomEvent("selected-item-changed", { detail: { item: _this.selectedItem, oldItem: undefined }, bubbles: true });
                _this.element.dispatchEvent(itemChangedEvent);
            });
        }
    };
    ComboBox.prototype.selectedItemChanged = function (newValue, oldValue) {
        var _this = this;
        if (newValue === oldValue || !this.isAttached) {
            return;
        }
        this.selectedValue = this.getValue(newValue);
        this.indexFocusedLi = this.filteredItemSource.indexOf(this.selectedItem) % this.filteredItemSource.length;
        setTimeout(function () {
            var itemChangedEvent = new CustomEvent("selected-item-changed", { detail: { item: newValue, oldItem: oldValue }, bubbles: true });
            _this.element.dispatchEvent(itemChangedEvent);
        });
    };
    ComboBox.prototype.isEditingChanged = function (newValue, oldValue) {
        var _this = this;
        if (newValue) {
            setTimeout(function () { return _this.focusTextBox(true); });
            this.searchValue = this.getDisplayName(this.selectedItem);
            if (this.internalItemSource) {
                this.filteredItemSource = this.internalItemSource.toArray();
            }
        }
    };
    ComboBox.prototype.focusTextBox = function (selectAlltext) {
        if (selectAlltext === void 0) { selectAlltext = false; }
        var input = this.input;
        if (!input)
            return;
        setTimeout(function () {
            input.focus();
            if (selectAlltext) {
                input.select();
            }
        });
    };
    ComboBox.prototype.onFocus = function () {
        this.isFocused = true;
        this.isEditing = true;
        this._focusCount++;
        if (this.isMobile && this._focusCount % 2 == 0) {
            this.input.removeAttribute('readonly');
        }
    };
    ComboBox.prototype.onBlured = function () {
        this.isFocused = false;
        this.isEditing = false;
        this.isDropdownOpen = false;
        if (this.isMobile) {
            this.input.removeAttribute('readonly');
        }
    };
    ComboBox.prototype.itemSourceChanged = function (newValue, oldValue) {
        var _this = this;
        if (newValue === oldValue || !this.isAttached) {
            return;
        }
        this.searchValue = "";
        if (newValue && this.selectedValue) {
            var selectedValueStringified_1 = JSON.stringify(this.selectedValue);
            var condition_2 = function (x) { return JSON.stringify(_this.getValue(x)) == selectedValueStringified_1 || _this.getValue(x) == _this.selectedValue; };
            this.selectedItem = this.internalItemSource.firstOrDefault(condition_2);
        }
        else if (newValue && this.selectedItem) {
            var selectedItemStringified_2 = JSON.stringify(this.selectedItem);
            var condition_3 = function (x) { return JSON.stringify(x) == selectedItemStringified_2 || x == _this.selectedItem; };
            this.selectedValue = this.getValue(this.internalItemSource.firstOrDefault(condition_3));
        }
        var selectedItemStringified = JSON.stringify(this.selectedItem);
        var condition = function (x) { return JSON.stringify(x) == selectedItemStringified || x == _this.selectedItem || (_this.selectedItem && x[_this.selectedValuePath] == _this.selectedItem[_this.selectedValuePath]); };
        var itemExists = newValue ? newValue.filter(condition)[0] : null;
        if (this.setDefault && !itemExists && newValue) {
            if (typeof this.setDefault == "function") {
                var item = this.setDefault(this.internalItemSource.toArray());
                if (item) {
                    this.select(item);
                }
            }
            else {
                this.select(this.internalItemSource.firstOrDefault());
            }
        }
    };
    ComboBox.prototype.searchValueChanged = function (newValue, oldValue) {
        this.applySearchFilter(newValue);
    };
    ComboBox.prototype.applySearchFilter = function (newValue) {
        var _this = this;
        if (this.internalItemSource) {
            if (newValue != null && newValue.length > 0) {
                this.filteredItemSource = this.internalItemSource
                    .where(function (x) {
                    var displayName = _this.getDisplayName(x);
                    return displayName && displayName.toString().toLowerCase().indexOf(newValue.toString().toLowerCase()) !== -1;
                }).toArray();
            }
            else {
                this.filteredItemSource = this.internalItemSource.toArray();
            }
        }
    };
    ComboBox.prototype.onSelect = function () {
        var _this = this;
        setTimeout(function () {
            var paramsEvent = { detail: _this.selectedItem, bubbles: true };
            var changeEvent = new CustomEvent("item-selected", paramsEvent);
            _this.element.dispatchEvent(changeEvent);
        });
    };
    ComboBox.prototype.open = function (event) {
        if (!this.disabled && !this.readonly && !this.isDropdownOpen) {
            if (!this.isDropdownOpen) {
                event.stopPropagation();
                this.eventAggrigator.publish(Messages.documentClick, {});
                if (!this.readonly && !this.disabled) {
                    this.isEditing = !this.isEditing;
                }
                this.isDropdownOpen = !this.isDropdownOpen;
                if (this.isMobile && this.input) {
                    this.input.setAttribute('readonly', 'readonly');
                }
            }
            else {
                this.isEditing = !this.isEditing;
                this.isDropdownOpen = !this.isDropdownOpen;
            }
            var internalItemSource = this.internalItemSource.toArray();
            this.indexFocusedLi = internalItemSource.indexOf(this.selectedItem) % internalItemSource.length;
        }
    };
    ComboBox.prototype.setDefaultChanged = function (newValue, oldValue) {
        var source = this.internalItemSource;
        if (this.setDefault && source && !this.selectedItem && !this.selectedValue) {
            if (typeof this.setDefault == "function") {
                var item = this.setDefault(source.toArray());
                if (item) {
                    this.select(item);
                }
            }
            else {
                this.select(source.firstOrDefault());
            }
        }
    };
    ComboBox.prototype.getTop = function (elem) {
        if (!elem || !elem.getBoundingClientRect) {
            return 0;
        }
        var rect = elem.getBoundingClientRect();
        var doc = elem.ownerDocument;
        var docElem = doc.documentElement;
        var win = doc.defaultView;
        return rect.top + win.pageYOffset - docElem.clientTop;
    };
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], ComboBox.prototype, "displayMemberPath", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ComboBox.prototype, "canEdit", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ComboBox.prototype, "isEditing", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ComboBox.prototype, "searchValue", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ComboBox.prototype, "selectedValuePath", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], ComboBox.prototype, "itemSource", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ComboBox.prototype, "readonly", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ComboBox.prototype, "disabled", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], ComboBox.prototype, "selectedItem", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], ComboBox.prototype, "selectedValue", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ComboBox.prototype, "placeholder", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ComboBox.prototype, "label", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ComboBox.prototype, "info", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], ComboBox.prototype, "itemsToHide", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], ComboBox.prototype, "setDefault", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ComboBox.prototype, "isDropdownOpen", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ComboBox.prototype, "showOnAdorner", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ComboBox.prototype, "isFocused", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], ComboBox.prototype, "isSearchable", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ComboBox.prototype, "groupHeaderPath", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], ComboBox.prototype, "disabledItemPath", void 0);
    ComboBox = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [Element, EventAggregator, BindingEngine])
    ], ComboBox);
    return ComboBox;
}());
export { ComboBox };
var DropDownContext = /** @class */ (function () {
    function DropDownContext(comboBoxContext) {
        this.comboBoxContext = comboBoxContext;
    }
    return DropDownContext;
}());
export { DropDownContext };
